import { render, staticRenderFns } from "./FormBlockText.vue?vue&type=template&id=7b8665da&scoped=true&"
import script from "./FormBlockText.vue?vue&type=script&lang=js&"
export * from "./FormBlockText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8665da",
  null
  
)

export default component.exports